import { rgba } from 'polished';
import { colors } from './colors';

export interface IBorders {
  black: string;
  offBlack: string;
  offBlack2: string;
  opaqueWhite: string;
  white: string;
}

export const borders: IBorders = {
  // to mimic a 0.5px border width, which shows up as 1px on most browsers
  black: `1px solid ${rgba(colors.black, 0.7)}`,
  offBlack: `1px solid ${rgba(colors.offBlack, 0.7)}`,
  offBlack2: `1px solid ${rgba(colors.offBlack2, 0.7)}`,
  white: `1px solid ${rgba(colors.white, 0.3)}`,
  opaqueWhite: `1px solid ${rgba(colors.white, 0.7)}`,
};
